// extracted by mini-css-extract-plugin
export var searchBox = "index-module--searchBox--wxd7i";
export var cardList = "index-module--cardList---XpsM";
export var card = "index-module--card--cRGJo";
export var name = "index-module--name--ratG7";